export const REPORT_FCI_ACTION = 'REPORT_FCI';
export const REPORT_FCI_ENDPOINT = 'fci';
